import { Injectable } from '@angular/core';

import { of as observableOf, Observable } from 'rxjs';


import { NbAuthResult, NbAuthStrategyClass, NbPasswordAuthStrategy, NbPasswordAuthStrategyOptions } from '@nebular/auth';
import { map } from 'rxjs/operators';


@Injectable()
export class NbSamlPassOAuthProvider extends NbPasswordAuthStrategy {


    static setup(options: NbPasswordAuthStrategyOptions): [NbAuthStrategyClass, NbPasswordAuthStrategyOptions] {
        return [NbSamlPassOAuthProvider, options];
    }

    authenticate(data?: any): Observable<NbAuthResult> {
        const token = this.createToken(this.getOption('token.getter')('login', data, this.options));
        const v = token.getValue();
        if (token) {
            const auth_result = new NbAuthResult(true,
                data,
                this.getOption('login.redirect.success'),
                [],
                this.getOption('messages.getter')('login', data, this.options),
                this.createToken(this.getOption('token.getter')('login', data, this.options)),
            );

            return observableOf(auth_result);

        }

        return super.authenticate(data);
    }
	/*
	  refreshToken(): Observable<NbAuthResult> {
		this.oauthService.refreshToken();
		console.log("refreshtoken")
		return Observable.of(new NbAuthResult(true, null, "index.html"));
	  }


	  user: Utente;

	  get roles() {
		return JSON.parse(sessionStorage.getItem(ROLES));
	  }

	  private oauthService: OAuthService;
	  constructor(injector: Injector) {
	   // super();
		this.oauthService = injector.get(OAuthService);
		this.oauthService.configure(authPasswordFlowConfig);
	  }

	  storeToken(tokenResponse) {
		  // this.oauthService.eventsSubject.next(new OAuthSuccessEvent('token_received'))
	  }

	  authenticate(tokenResponse?: any): Observable<NbAuthResult> {
		console.log("authentication");

		sessionStorage.setItem('access_token', tokenResponse.accessToken);
		sessionStorage.setItem('access_token_stored_at', '' + Date.now());
		if (tokenResponse.expiresIn) {
			var  expiresInMilliSeconds = tokenResponse.expiresIn * 1000;
			var  now = new Date();
			var expiresAt = now.getTime() + expiresInMilliSeconds;
			sessionStorage.setItem('expires_at', '' + expiresAt);
		}

		if (tokenResponse.refreshToken) {
		  sessionStorage.setItem('refresh_token', tokenResponse.refreshToken);
		}
		sessionStorage.setItem(ROLES, JSON.stringify(tokenResponse["scope"]));

		return Observable.of(
			   new NbAuthResult(
				true,
				tokenResponse,
				"index.html",
				[],
				"Accesso eseguito correttamente"
			   )
			  );
	  }

	  register(): Observable<NbAuthResult> {
		return null;
	  }

	  requestPassword(): Observable<NbAuthResult> {
		return null;
	  }

	  resetPassword(): Observable<NbAuthResult> {
		return null;
	  }
	  logout(): Observable<NbAuthResult> {
		this.oauthService.logOut(true);
		sessionStorage.removeItem(ROLES);
		this.user = null;
		return Observable.of(new NbAuthResult(false, null, "index.html"));
	  }
	  protected getActionEndpoint(): string {
		return "aaa";
	  }
	*/
}
